module.exports = __webpack_public_path__ + "img/yirenzheng.230254ab.png";